import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "pp-lottery-winnings" }
const _hoisted_2 = {
  key: 0,
  class: "pp-lottery-winnings__description"
}
const _hoisted_3 = ["innerHTML"]

import { computed, ref } from "vue";
import { StringUtils } from "@sazka/utils/string-utils";
import DsTable from "@sazka/design-system/src/table/ds-table.vue";
import DsRow from "@sazka/design-system/src/table-row/ds-table-row.vue";
import DsCell from "@sazka/design-system/src/table-cell/ds-table-cell.vue";
import DsDropdown from "@sazka/design-system/src/forms/components/ds-dropdown.vue";
import { DsDropdownItemModel } from "@sazka/design-system/src/forms/components/ds-dropdown/ds-dropdown-models";
import { PpDraw } from "@/lotteries/services/model/draw";


export default /*@__PURE__*/_defineComponent({
  __name: 'pp-rychla-6-winnings',
  props: {
    results: {}
  },
  setup(__props: any) {

const options: DsDropdownItemModel[] = [
    { value: 0, label: "SÁZKA ZA 10 KČ AŽ 100 KČ" },
    { value: 1, label: "HLAVNÍ HRA ZA 200 KČ AŽ 500 KČ" },
    { value: 2, label: "SUDÁ, NEBO LICHÁ" },
    { value: 3, label: "NÍZKÁ, NEBO VYSOKÁ" },
];



const selectedOption = ref(0);
const isSubgameSelected = computed(() => selectedOption.value >= 2);

const winningOrdersGrid = [
    [
        [6, 10_000],
        [9, 250],
        [12, 50],
        [15, 5],
        [18, 3],
        [21, 1],
    ],
    [
        [6, 12_500],
        [9, 250],
        [12, 50],
        [15, 5],
        [18, 3],
        [21, 1],
    ],
    [["Převaha sudých čísel"], ["Stejný počet"], ["Převaha lichých čísel"]],
    [["Převaha nízkých čísel"], ["Stejný počet"], ["Převaha vysokých čísel"]],
];

const formatMultiple = (multiple: number) => `${StringUtils.formatNumber(multiple)}x`;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(DsDropdown, {
      modelValue: selectedOption.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedOption).value = $event)),
      options: options,
      id: "winnings-dropdown"
    }, null, 8, ["modelValue"]),
    (!isSubgameSelected.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Výše výherního násobku závisí na tom, kolik čísel bylo nutné vylosovat, než padla ta vaše. Proto čím nižší číslo je ve sloupci Počet čísel, tím vyšší je výherní násobek. "))
      : _createCommentVNode("", true),
    _createVNode(DsTable, null, {
      default: _withCtx(() => [
        (!isSubgameSelected.value)
          ? (_openBlock(), _createBlock(DsRow, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(DsCell, { type: "th" }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createTextVNode("Pořadí")
                  ])),
                  _: 1,
                  __: [1]
                }),
                _createVNode(DsCell, { type: "th" }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode("Počet čísel")
                  ])),
                  _: 1,
                  __: [2]
                }),
                _createVNode(DsCell, { type: "th" }, {
                  default: _withCtx(() => _cache[3] || (_cache[3] = [
                    _createTextVNode("Výherní násobek")
                  ])),
                  _: 1,
                  __: [3]
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!isSubgameSelected.value)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(winningOrdersGrid[selectedOption.value], (order, index) => {
              return (_openBlock(), _createBlock(DsRow, { key: index }, {
                default: _withCtx(() => [
                  _createVNode(DsCell, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(index + 1) + ". pořadí", 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(DsCell, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(order[0]), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(DsCell, null, {
                    default: _withCtx(() => [
                      _createElementVNode("strong", {
                        innerHTML: formatMultiple(order[1] as number)
                      }, null, 8, _hoisted_3)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 128))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(winningOrdersGrid[selectedOption.value], (order, index) => {
              return (_openBlock(), _createBlock(DsRow, { key: index }, {
                default: _withCtx(() => [
                  _createVNode(DsCell, {
                    class: "pp-r6-subgame",
                    type: "th"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(order[0]), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(DsCell, { class: "pp-r6-subgame" }, {
                    default: _withCtx(() => _cache[4] || (_cache[4] = [
                      _createElementVNode("strong", null, "2x", -1)
                    ])),
                    _: 1,
                    __: [4]
                  })
                ]),
                _: 2
              }, 1024))
            }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})